module.exports = "https://coursera_assets.s3.amazonaws.com/images/a07134c4ff254ca6f8c9e910914955e5.png";